
/**
 * @Description 测距工具快捷面板
 */
import IconFont from '@/common/components/IconFont';
import styles from './index.module.less';
import cs from 'classnames';
import { rulers, RulerType } from '../ts-config';
import { message } from 'antd';
import { useEffect, useRef } from 'react';

const RulerShortCutPanel = ({
  rulering, // 测距状态
  rulerType, // 测距类型
  setRulerType, // 更新测距类型 0：关闭测距
  setIsShowPanel, // 是否显示快捷面板
  setIsCheckInsideMapOperate,
  floatDirection = 'right',
  finallyShowStatus,
  setTargetOperation,
  setIsShowInputPanel, // 点击「输入」类型时切换到 RulerInputPanel；由 ToolBox 注入
}) => {

  const isCloseTypeInputRef: any = useRef<boolean>(false); // 是否因为要切换到输入模式测距而关闭本弹框

  const onClose = () => {
    setRulerType(0);
    setIsShowPanel(false);
    setIsCheckInsideMapOperate?.(false);
    setTargetOperation('');
    finallyShowStatus?.(false);
  };
  const onChange = (type) => {
    if (rulering) {
      message.warning('请先结束本次测距!');
      return;
    }; // 测距状态中不允许切换类型
    // type === 「输入」走独立分支：切换到 RulerInputPanel
    if (type === RulerType.Input) {
      isCloseTypeInputRef.current = true;
      setIsShowPanel(false);
      setIsShowInputPanel(true);
      return;
    }
    setRulerType(type);
  };


  useEffect(() => {
    return () => {
      if (isCloseTypeInputRef.current) return;
      onClose();
    };
  }, []);

  return (
    <>
      <div
        className={cs(styles.shortcutPanel, floatDirection === 'left' && styles.shortcutPanelLeft)}>

        <div className={styles.panel}>
          {rulers.map((item) => (
            <div
              key={item.type}
              className={
                cs(styles.panelItem,
                  rulerType === item.type && styles.panelItemSelected)}
              onClick={() => onChange(item.type)} // 变更测距类型
            >
              <div className={cs(styles.icon, rulerType === item.type && styles.iconSelected)}>
                <IconFont
                  iconHref={item.icon}
                />
              </div>
              <span className={styles.name}>{item.name}</span>
            </div>
          ))}
        </div>
        <span className={styles.line} />
        <div className={styles.shortcut} onClick={onClose}>
          退出测距
        </div>
      </div>
    </>
  );
};

export default RulerShortCutPanel;
